import { alpha } from '@mui/material';

export const ORGANISATION_AVATAR_COLOR = '#10B981';

export const getOrganisationInitials = (name: string): string => {
    const words = name.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return 'OR';
    }

    if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
    }

    return words.slice(0, 2).map(word => word[0]).join('').toUpperCase();
};

export const formatStatusLabel = (status?: string | null): string => {
    if (!status) {
        return 'Unknown';
    }

    return status
        .replace(/_/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
};

export const getStatusColor = (status?: string | null): string => {
    const normalised = status?.toLowerCase();
    if (normalised === 'active') {
        return '#10B981';
    }
    if (normalised === 'suspended' || normalised === 'inactive') {
        return '#F59E0B';
    }
    return '#6B7280';
};

export const formatDate = (value?: string | null): string => {
    if (!value) {
        return '--';
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return '--';
    }

    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date);
};

export const organisationAvatarSx = {
    bgcolor: alpha(ORGANISATION_AVATAR_COLOR, 0.15),
    color: ORGANISATION_AVATAR_COLOR,
    border: `1px solid ${alpha(ORGANISATION_AVATAR_COLOR, 0.3)}`,
};
